export default __webpack_public_path__ + "static/media/ico-generic-db-score-moderate.e9d88ac7.svg";